import {
  Person,
  Phone,
  Edit,
  Notifications,
  Logout,
  Email,
  Settings,
  AccountBalance,
  Business,
} from '@mui/icons-material'
import { doLogout } from 'feature/auth/redux/action/doLogout'
import { statusTexts } from 'feature/user/helpers/statusText'
import { formatPhoneNumber } from 'helpers/phones'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'ui'
import { LoaderInCentalPosition } from 'widget'
import { MenuBlockWithIcon } from 'widget/MenuBlockWithIcon/MenuBlockWithIcon'

import { ModalConfirm } from 'feature/user/components/ModalConfirm/ModalConfirm'
import { useGetUserQuery } from 'feature/user/redux/user.api'

import { useThunkDispatch } from 'store/hooks/useThunkDispatch'
import style from './UserSettings.module.scss'

export function UserSettings() {
  const navigate = useNavigate()
  const [isModalOpen, setModalOpen] = useState<boolean>(false)
  const handleOpenModal = () => setModalOpen(true)
  const { data, isLoading } = useGetUserQuery()

  const emailStatus: 'done' | 'progress' = data?.newEmail ? 'progress' : 'done'
  const fatherName = data?.fatherName ? data.fatherName : ''
  const isEmailExist = data?.newEmail || data?.email

  const thunkDispatch = useThunkDispatch()
  const logOutHandler = () => {
    thunkDispatch(doLogout())
    navigate('/')
  }

  const isCompany = data?.clientType === 'company'
  const profileSubText = isCompany ? (
    <>
      <span className={style.companyName}>{data?.companyName}</span>
      <span>ИНН: {data?.inn}</span>
    </>
  ) : (
    data?.customerAddress.address
  )

  if (isLoading || !data) return <LoaderInCentalPosition />
  if (!isLoading && !data) return <></>

  return (
    <section className={style.settingPage}>
      <div>
        <div className={style.title}>
          <Settings color='primary' />
          <span className='h1'>настройки</span>
        </div>
        <div className={style.settingMenu}>
          <MenuBlockWithIcon
            link='/settings/edit'
            text={`${data.lastName} ${data.firstName} ${fatherName}`}
            subText={profileSubText}
            startIcon={
              isCompany ? (
                <Business color='primary' />
              ) : (
                <Person color='primary' />
              )
            }
            endIcon={<Edit color='primary' />}
            data-testid='settings-profile'
          />

          <MenuBlockWithIcon
            text={formatPhoneNumber(data.phone)}
            disabled
            startIcon={<Phone color='primary' />}
            data-testid='settings-phone'
          />

          <MenuBlockWithIcon
            link='/settings/email'
            text={isEmailExist || 'E-mail'}
            subText={
              !isEmailExist
                ? 'Если хотите получать чеки по заказам, введите адрес Email'
                : ''
            }
            statusText={isEmailExist ? statusTexts[emailStatus] : ''}
            status={emailStatus}
            startIcon={<Email color='primary' />}
            endIcon={<Edit color='primary' />}
            data-testid='settings-email'
          />

          <MenuBlockWithIcon
            link='/settings/notice'
            text='Уведомления'
            startIcon={<Notifications color='primary' />}
            endIcon={<Edit color='primary' />}
            data-testid='settings-notices'
          />

          {isCompany && (
            <MenuBlockWithIcon
              link='/settings/bank-details'
              text='Банковские реквизиты'
              startIcon={<AccountBalance color='primary' />}
              endIcon={<Edit color='primary' />}
              data-testid='settings-bank-details'
            />
          )}
        </div>
      </div>

      <Button
        startIcon={<Logout color='primary' />}
        variant='contained'
        color='secondary'
        type='button'
        onClick={handleOpenModal}
        className={style.logoutBtn}
        data-testid='settings-logout'
      >
        Выйти
      </Button>

      <ModalConfirm
        onConfirm={logOutHandler}
        cancelText='Отмена'
        actionText='Да'
        isModalOpen={isModalOpen}
        onCancel={() => setModalOpen(false)}
      />
    </section>
  )
}
